export default __webpack_public_path__ + "e2b1b241d52ebb50be31f39dc83326e8.svg";